<section class="content-layout">
  <bw-action-article-legacy [brightsideWebFb]="{ event_name: 'credit_setup_error' }">

    <ui-nav-exit-back
        back-action-bottom
        [trackingDetail]="{ event_name: 'credit_smfa' }"
        (exitActionHandler)="routeUserOnBack()"
    ></ui-nav-exit-back>

    <div content-section>
      <div class="flex-column space-center mb-xl">
        <img src="../assets/warning-exclamation.png"  class="mb-md" />
        <p title-medium class="mb-sm">{{ 'ERROR_CREDIT_FAILED_TITLE' | translate }}</p>
        <typography-legacy text-large-regular color="var(--secondary-text)">
          <p class="center" style="max-width: 432px; white-space: pre-wrap">
            {{ 'ERROR_CREDIT_FAILED_ATTEMPTS' | translate }}
          </p>
        </typography-legacy>
      </div>
    </div>

    <div footer-actions  class="flex-column">
      <button            
        bw-button-legacy      
        [brightsideWebFb]="{ event_name: 'credit_smfa' }"
        (click)="handleClick()">
        {{ 'MESSAGE_FA' | translate }}
      </button>
    </div>
  </bw-action-article-legacy>
</section>